import { useEffect, useState } from 'react';

import signatureSample from '../../../assets/signature-sample.png';
import { usePokCore } from '../../../common/hooks/usePokCore';

export interface PreviewImage {
  src: string;
  width: number;
  height: number;
}

const loadPreviewImage = (src: string) =>
  new Promise<PreviewImage>((resolve, reject) => {
    const image = new Image();
    image.onload = () =>
      resolve({ src, width: image.naturalWidth, height: image.naturalHeight });
    image.onerror = reject;
    image.src = src;
  });

// Images shown inside the signature frame: a sample signature (the real one
// of the authorized person is never shown) and the stamp of the company.
export const useSignaturePreviewImages = (enabled: boolean) => {
  const pok = usePokCore();
  const [signature, setSignature] = useState<PreviewImage>();
  const [stamp, setStamp] = useState<PreviewImage>();

  useEffect(() => {
    if (!enabled) {
      return;
    }
    let cancelled = false;
    loadPreviewImage(signatureSample)
      .then(image => !cancelled && setSignature(image))
      .catch(() => undefined);
    pok.companies
      .getById(pok.getCompanyId())
      .then(company =>
        company.stamp ? loadPreviewImage(company.stamp) : undefined,
      )
      .then(image => !cancelled && setStamp(image))
      // Without a stamp the frame is shown without it; signing reports it.
      .catch(() => undefined);
    return () => {
      cancelled = true;
    };
  }, [enabled, pok]);

  return { signature, stamp };
};
